// 進站時的存取判定。M9 把守門分成三態，前端也要分——使用者的下一步完全不同：
// 重新登入 ／ 聯絡客服開通 ／ 稍後再試。全部顯示同一句話等於把那個區分丟掉。
export type AccessState = 'ok' | 'unauthenticated' | 'forbidden' | 'unavailable'

// 主網域登入頁網址由伺服器在執行期提供（各環境不同）。
// 🔴 取不到回 null、不退到任何預設網域：猜錯環境會把 test 使用者導去正式站。
export const fetchMainLoginUrl = async (): Promise<string | null> => {
  try {
    const res = await fetch('/api/ai/public-config')
    if (!res.ok) return null
    const body = (await res.json()) as { mainLoginUrl?: unknown }
    return typeof body.mainLoginUrl === 'string' && body.mainLoginUrl !== '' ? body.mainLoginUrl : null
  } catch {
    return null
  }
}

// 用最輕的一支受守門端點探測。🔴 只有這三個狀態整頁擋下來：
// 其他狀態（例如下游掛了的 500）交給各頁自己的錯誤處理，不要把整個 app 遮掉。
export const probeAccess = async (): Promise<AccessState> => {
  const res = await fetch('/api/ai/service-status')
  if (res.status === 401) return 'unauthenticated'
  if (res.status === 403) return 'forbidden'
  if (res.status === 503) return 'unavailable'
  return 'ok'
}
